import { render } from "./account-plus.vue?vue&type=template&id=3ddc3470"
import script from "./account-plus.vue?vue&type=script&lang=js"
export * from "./account-plus.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__